export default "__VITE_ASSET__94ceb061__"